import { render } from "./PasswordResetMask.vue?vue&type=template&id=39302435&scoped=true"
import script from "./PasswordResetMask.vue?vue&type=script&lang=js"
export * from "./PasswordResetMask.vue?vue&type=script&lang=js"

import "./PasswordResetMask.vue?vue&type=style&index=0&id=39302435&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39302435"]])

export default __exports__